module.exports = __webpack_public_path__ + "img/0002.35695917.jpg";